import axios from 'axios'
 
export default class {
  _constancyUrl
  constructor() {
    this._constancysUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_CONSTANCY}`
  }
 
  crearConstancia(data){
    return axios.post(`${this._constancysUrl}`, data)
  }
}
